<template>
  <div class="content">
    <ArtistSelect
      class="col-md-6"
      @memberChangeEvent="getArtistInfo"
      :show-members="false"
      :is-filter="true"
      :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
    />
    <form class="form-horizontal">
      <card class="text-left col-md-6">
        <template slot="header"> </template>
        <base-button @click="addSection()" type="success">섹션 추가</base-button>
        <base-button @click="saveUnitCards()" type="success">카드 저장</base-button>
        <base-button @click="clearCache()" type="danger">캐시 초기화</base-button>
        <base-button @click="copySections()" type="default">복사</base-button>
        <el-popover trigger="hover" placement="top">
          <div>
            <div class="popover-body">
              복사 클릭후 '카드 목록' 텍스트 위에서 Ctrl+v 하면 카드가 붙여넣기 됩니다<br />
              붙여넣기시 배너, 운영자설정 컨텐츠는 비노출 상태로 됩니다.
            </div>
          </div>
          <base-button slot="reference"> ? </base-button>
        </el-popover>
      </card>
      <div id="today_area" class="row">
        <div class="col-sm-12">
          <div class="row">
            <div @paste="onSectionPaste" class="col-sm-7">
              <h2>카드 목록</h2>
              <draggable v-model="sections" group="sections" @start="drag = true" @end="drag = false">
                <section class="section" v-for="(section, sectionIndex) in sections" :class="{ isVisible: section.isVisible, isInvisible: !section.isVisible }">
                  <p>
                    {{ section.title }}
                  </p>
                  <p>
                    {{ section.link }}
                  </p>
                  <base-button @click="addSectionCard(sectionIndex)" type="success">카드추가</base-button>
                  <base-button @click="setSectionForm(sectionIndex)" type="success">섹션설정</base-button>
                  <base-button @click="deleteSection(sectionIndex)" type="danger">X</base-button>
                  <draggable class="row" v-model="section.cards" group="cards" @start="drag = true" @end="drag = false">
                    <card v-for="(card, index) in section.cards" class="card" :class="{ isVisible: card.isVisible, isInvisible: !card.isVisible }">
                      <p class="card-text">
                        <el-select @change="setCardType(card)" class="select-primary" size="large" placeholder="선택" v-model="card.type">
                          <el-option v-for="cardType in cardTypes" class="select-primary" :value="cardType.type" :label="cardType.name" :key="cardType.name" />
                        </el-select>
                      </p>
                      <p><img v-if="card.iconUrl" style="width: 24px" :src="card.iconUrl" /> {{ card.title }}</p>
                      <p>{{ card.description }}</p>
                      <p>{{ card.link }}</p>
                      <p>
                        <base-button v-if="card.type !== 999 && card.type" @click="setCardForm(sectionIndex, index)" type="success">카드설정</base-button>
                        <base-button v-if="card.type !== 999 && card.type" @click="copyCard(sectionIndex, index)" type="success">카드복사</base-button>
                        <base-button @click="deleteCard(sectionIndex, index)" type="danger">X</base-button>
                      </p>
                    </card>
                  </draggable>
                  <hr class="hasSeparator" v-if="section.hasSeparator" />
                </section>
              </draggable>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-6 float">
              <div v-if="sectionSet">
                <h2>{{ sectionSet.sectionIndex + 1 }}번 섹션 설정</h2>
                <div class="row">
                  <label @click="showMessage(sectionSet.title)" class="col-sm-4 col-form-label">타이틀 KEY</label>
                  <div class="col-sm-8">
                    <base-input placeholder="타이틀 KEY" v-model="sectionSet.title">
                      <span slot="helpBlock" class="form-text" />
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-4 col-form-label">링크</label>
                  <div class="col-sm-8">
                    <LinkSelect @linkChangeEvent="getLink" class="link-selection" link-model="sectionSet.link" />
                    <base-input placeholder="링크" v-model="sectionSet.link">
                      <span slot="helpBlock" class="form-text" />
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-4 col-form-label">하단구분선</label>
                  <div class="col-sm-8">
                    <base-switch v-model="sectionSet.hasSeparator" type="primary" on-text="ON" off-text="OFF"></base-switch>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-4 col-form-label">노출여부</label>
                  <div class="col-sm-8">
                    <base-switch v-model="sectionSet.isVisible" type="primary" on-text="ON" off-text="OFF"></base-switch>
                  </div>
                </div>
              </div>
              <div v-if="cardSet">
                <h2>{{ cardSet.name }} 카드 설정</h2>
                <div class="row">
                  <label @click="showMessage(cardSet.title)" class="col-sm-4 col-form-label">타이틀 KEY</label>
                  <div class="col-sm-8">
                    <base-input placeholder="타이틀 KEY" v-model="cardSet.title">
                      <span slot="helpBlock" class="form-text" />
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <label @click="showMessage(cardSet.description)" class="col-sm-4 col-form-label">설명 KEY</label>
                  <div class="col-sm-8">
                    <base-input placeholder="설명 KEY" v-model="cardSet.description">
                      <span slot="helpBlock" class="form-text" />
                    </base-input>
                  </div>
                </div>

                <div class="row">
                  <label class="col-sm-4 col-form-label">링크</label>
                  <div class="col-sm-8">
                    <LinkSelect @linkChangeEvent="getLink" class="link-selection" link-model="cardSet.link" />
                    <base-input placeholder="링크" v-model="cardSet.link">
                      <span slot="helpBlock" class="form-text" />
                    </base-input>
                  </div>
                </div>

                <div class="row" v-if="cardSet.type === 701">
                  <label class="col-sm-4 col-form-label">시작시간</label>
                  <div class="col-sm-8">
                    <el-date-picker type="datetime" placeholder="시작시간" v-model="cardSet.startTime"></el-date-picker>
                  </div>
                </div>
                <div class="row" v-if="cardSet.type === 701">
                  <label class="col-sm-4 col-form-label">종료시간</label>
                  <div class="col-sm-8">
                    <el-date-picker type="datetime" placeholder="종료시간" v-model="cardSet.endTime"></el-date-picker>
                  </div>
                </div>

                <div class="row">
                  <label class="col-sm-4 col-form-label">아이콘</label>
                  <div class="col-sm-8">
                    <el-select @change="setIconUrl(cardSet)" class="select-primary" size="large" placeholder="선택" v-model="cardSet.icon">
                      <el-option v-for="icon in icons" class="select-primary" :value="icon.value" :label="icon.name" :key="icon.name" />
                    </el-select>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-4 col-form-label">노출여부</label>
                  <div class="col-sm-8">
                    <base-switch v-model="cardSet.isVisible" type="primary" on-text="ON" off-text="OFF"></base-switch>
                  </div>
                </div>
                <div v-if="cardSet.type === 901">
                  <base-button @click="openBannerDialog(cardSet)" type="success">상세설정</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <BannerModal
      :key="bannerModal.componentKey"
      :sectionIndex="bannerModal.sectionIndex"
      :cardIndex="bannerModal.cardIndex"
      :banners="bannerModal.banners"
      :unitId="unitId"
      :shouldShow="bannerModal.show"
      :onConfirm="onBannerModal"
      :onCancel="onCancelBannerModal"
    ></BannerModal>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import LinkSelect from "@/pages/Components/LinkSelect.vue";
import { BaseInput, BaseSwitch, Card } from "@/components/index";
import draggable from "vuedraggable";
import BannerModal from "./BannerModal.vue";
import Endpoints from "@/common/Endpoints";
import { URLUtils } from "@/util/URLUtils";

export default {
  components: {
    ArtistSelect,
    LinkSelect,
    Card,
    draggable,
    BaseInput,
    BannerModal,
    BaseSwitch,
  },
  async created() {
    await this.getTodayCardTypes();
    await this.getLanguageFiles();
  },
  data() {
    return {
      unitId: null,
      bannerModal: {
        componentKey: 1000,
        show: false,
        sectionIndex: null,
        cardIndex: null,
        banners: [],
      },
      languages: [],
      cardTypes: [],
      sections: [],
      cardSet: null,
      sectionSet: null,
      icons: [
        {
          url: null,
          name: "없음",
          value: null,
        },
        {
          url: "https://static.blip.kr/today/icon/youtube.png",
          name: "YOUTUBE",
          value: "YOUTUBE",
        },
        {
          url: "https://static.blip.kr/today/icon/twitter.png",
          name: "TWITTER",
          value: "TWITTER",
        },
        {
          url: "https://static.blip.kr/today/icon/sharp.png",
          name: "HASHTAG",
          value: "HASHTAG",
        },
      ],
    };
  },
  methods: {
    async getLanguageFiles() {
      return this.$axios.get(`/language/folder`).then((res) => {
        this.languages = res.data.data;
      });
    },
    clone: function (original) {
      let count = 0;
      for (const section of this.sections) {
        for (const card of section.cards) {
          if (card.type === original.type) {
            count++;
          }
        }
      }
      if (original.cardLimit <= count) {
        window.Toast.error("더 이상 추가할수 없는 카드타입입니다");
        return;
      }
      let element = {};
      for (let key in original) {
        if (original.hasOwnProperty(key)) {
          element[key] = original[key];
        }
      }
      return element;
    },
    openBannerDialog(cardSet) {
      this.bannerModal.sectionIndex = cardSet.sectionIndex;
      this.bannerModal.cardIndex = cardSet.index;
      this.bannerModal.banners = _.cloneDeep(cardSet.banners) ?? [];
      this.bannerModal.componentKey++;
      this.bannerModal.show = true;
    },
    async onBannerModal(banners) {
      this.sections[this.bannerModal.sectionIndex].cards[this.bannerModal.cardIndex].banners = banners;
      this.bannerModal.show = false;
    },
    setCardType(card) {
      let count = 0;
      for (const section of this.sections) {
        for (const sectionCard of section.cards) {
          if (sectionCard.type === card.type) {
            count++;
          }
        }
      }
      const cardType = this.cardTypes.filter((cardType) => cardType.type === card.type)[0];
      if (cardType.cardLimit < count) {
        window.Toast.error(`해당카드는 ${cardType.cardLimit}개 까지 추가가능합니다`);
        card.type = null;
        this.cardSet = null;
        return;
      }
      card.name = cardType.name;
    },
    onCancelBannerModal() {
      this.bannerModal.show = false;
      this.bannerModal.banners = this.cardSet.banners ?? [];
    },
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.sectionSet = null;
      this.cardSet = null;
      await this.getCards();
    },
    getLink(param) {
      const linkModel = param.linkModel.split(".");
      if (linkModel.length === 1) {
        this[linkModel[0]] = param.value;
      } else if (linkModel.length === 2) {
        this[linkModel[0]][linkModel[1]] = param.value;
      } else if (linkModel.length === 3) {
        this[linkModel[0]][linkModel[1]][linkModel[2]] = param.value;
      }
    },
    async getTodayCardTypes() {
      return this.$axios.get(`/today/cardTypes`).then((res) => {
        this.cardTypes = res.data.data.map((d) => {
          d.title = null;
          d.link = null;
          d.description = null;
          d.startTime = null;
          d.endTime = null;
          d.icon = null;
          d.type = d.id;
          d.isVisible = true;
          return d;
        });
      });
    },
    deleteSection(sectionIndex) {
      this.sections.splice(sectionIndex, 1);
    },
    deleteCard(sectionIndex, index) {
      this.sections[sectionIndex].cards.splice(index, 1);
    },
    addSection() {
      this.sections.push({ title: null, link: null, cards: [], isVisible: true, hasSeparator: true });
    },
    addSectionCard(sectionIndex) {
      this.sections[sectionIndex].cards.push({ title: null, link: null, description: null, icon: null, isVisible: true });
    },
    setSectionForm(sectionIndex) {
      this.sectionSet = null;
      this.cardSet = null;
      const section = this.sections[sectionIndex];
      if (!section.isSaved) {
        // Toast.error("잘못된접근입니다");
        // return;
      }
      this.sectionSet = section;
      this.sectionSet.sectionIndex = sectionIndex;
    },
    setSection(sectionSet) {
      this.sections[sectionSet.sectionIndex].title = sectionSet.title;
      this.sections[sectionSet.sectionIndex].link = sectionSet.link;
    },
    setCardForm(sectionIndex, index) {
      this.sectionSet = null;
      this.cardSet = null;
      const card = this.sections[sectionIndex].cards[index];
      if (!card.isSaved) {
        // Toast.error("잘못된접근입니다");
        // return;
      }

      this.cardSet = card;
      this.cardSet.sectionIndex = sectionIndex;
      this.cardSet.index = index;
    },
    copyCard(sectionIndex, index) {
      const card = this.sections[sectionIndex].cards[index];
      const dom = document.createElement("textarea");
      document.body.appendChild(dom);
      dom.value = JSON.stringify(card);
      dom.select();
      document.execCommand("copy");
      document.body.removeChild(dom);
      window.Toast.success("클립보드에 카드가 복사되었습니다");
    },
    async getCards() {
      const queryParams = { unitId: this.unitId };
      const path = `/today/today?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      this.sections = [];
      return this.$axios.get(`/today/${this.unitId}/sectionCards`).then((res) => {
        this.sections = res.data.data.map((section) => {
          section.isSaved = true;
          section.hasSeparator = section.hasSeparator === 1;
          section.isVisible = section.isVisible === 1;
          section.cards.map((card) => {
            card.isSaved = true;
            card.isVisible = card.isVisible === 1;
            card.name = this.cardTypes.filter((type) => card.type === type.id)[0].name;
            this.setIconUrl(card);
            return card;
          });
          return section;
        });
      });
    },
    setIconUrl(cardSet) {
      cardSet.iconUrl = this.icons.filter((icon) => icon.value === cardSet.icon)[0]?.url;
    },
    showMessage(key) {
      this.languages.forEach((language) => {
        window.Toast.info(`${language.fileName}: ${language.data[key] ?? ""}`);
      });
    },
    async clearCache() {
      return this.$axios.put(`/today/${this.unitId}/cache`).then((res) => {
        window.Toast.success("캐시가 초기화 되었습니다");
      });
    },
    copySections() {
      const dom = document.createElement("textarea");
      document.body.appendChild(dom);
      dom.value = JSON.stringify(this.sections);
      dom.select();
      document.execCommand("copy");
      document.body.removeChild(dom);
      window.Toast.success("클립보드에 전체가 복사되었습니다");
    },
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },

    async saveUnitCards() {
      if (!this.unitId) {
        window.Toast.error("잘못된 접근입니다.");
        return;
      }
      for (const section of this.sections) {
        for (const card of section.cards) {
          if (!card.type) {
            window.Toast.error("카드를 선택해주세요");
            return;
          }
        }
      }
      const param = {
        sections: this.sections.map((section) => {
          section.hasSeparator = section.hasSeparator ? 1 : 0;
          section.isVisible = section.isVisible ? 1 : 0;
          section.cards = section.cards.map((card) => {
            card.isVisible = card.isVisible ? 1 : 0;
            return card;
          });
          return section;
        }),
      };

      return this.$axios.post(`/today/${this.unitId}`, param).then((res) => {
        window.Toast.success("등록되었습니다");
      });
    },
    onSectionPaste(e) {
      // Stop data actually being pasted into div
      e.stopPropagation();
      e.preventDefault();

      const pastedData = e.clipboardData.getData("text");

      try {
        const json = JSON.parse(pastedData);
        if (Array.isArray(json)) {
          this.sections = json.map((section) => {
            if (section.link) {
              if (section.link.indexOf(Endpoints.blipSchema) > -1) {
                section.link = this.updateQueryStringParameter(section.link, "unitId", this.unitId);
              }
            }
            section.cards = section.cards.map((card) => {
              if (card.type === 901) {
                card.banners = null;
                card.isVisible = false;
              } else if (card.type === 902) {
                card.contents = null;
                card.isVisible = false;
              } else {
                if (card.link) {
                  if (card.link.indexOf(Endpoints.blipSchema) > -1) {
                    card.link = this.updateQueryStringParameter(card.link, "unitId", this.unitId);
                  }
                }
              }
              return card;
            });
            return section;
          });
        } else if (typeof json === "object") {
          this.sections[0].cards.push(json);
        } else {
          window.Toast.error("잘못된 데이터입니다");
        }
      } catch (e) {
        window.Toast.error("잘못된 데이터입니다");
      }
    },

    updateQueryStringParameter(uri, key, value) {
      const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      const separator = uri.indexOf("?") !== -1 ? "&" : "?";
      if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
      } else {
        return uri + separator + key + "=" + value;
      }
    },
    callPasteFunctions() {
      const me = this;
      document.getElementById("card_list").addEventListener("paste", function (e) {
        var clipboardData, pastedData;

        // Stop data actually being pasted into div
        e.stopPropagation();
        e.preventDefault();

        // Get pasted data via clipboard API
        clipboardData = e.clipboardData || window.clipboardData;
        pastedData = clipboardData.getData("Text");

        function updateQueryStringParameter(uri, key, value) {
          var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
          var separator = uri.indexOf("?") !== -1 ? "&" : "?";
          if (uri.match(re)) {
            return uri.replace(re, "$1" + key + "=" + value + "$2");
          } else {
            return uri + separator + key + "=" + value;
          }
        }

        const sections = JSON.parse(pastedData);
        me.sections = sections.map((section) => {
          if (section.link) {
            if (section.link.indexOf(Endpoints.blipSchema) > -1) {
              section.link = updateQueryStringParameter(section.link, "unitId", me.unitId);
            }
          }
          section.cards = section.cards.map((card) => {
            if (card.type === 901) {
              card.banners = null;
              card.isVisible = false;
            } else if (card.type === 902) {
              card.contents = null;
              card.isVisible = false;
            } else {
              if (card.link) {
                if (card.link.indexOf(Endpoints.blipSchema) > -1) {
                  card.link = updateQueryStringParameter(card.link, "unitId", me.unitId);
                }
              }
            }
            return card;
          });
          return section;
        });
      });
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.bootstrap-switch {
  margin: 6px;
}
.section {
  padding-right: 25px;
  padding-left: 25px;
  margin-bottom: 5px;
  border: 5px solid #ff324b;
  border-radius: 25px;
}
.float {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 400px;
  background-color: white;
}

.isInvisible {
  background-color: #00000033;
}

.hasSeparator {
  border-top: 10px solid rgba(0, 0, 0, 0.5);
  margin-top: 0rem;
  margin-bottom: 0rem;
}
</style>
